




































import { Action } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import API from '@/Api';

const namespace: string = 'EmployeeStore';

@Component
export default class NewJoineesList extends Vue {
    @Prop() public showAllBtn!: boolean;
    @Action('getSearchProfile', { namespace }) public getSearchProfile!: any;
    public items: any[] =  [];
    public colors: string[] = ['light-green', 'light-blue', 'cyan', 'indigo', 'orange'];

    public mounted() {
      const url = this.showAllBtn === true ? '/api/new-joinees' : '/api/new-joinees?all=true';
      API.Instance
        .get(url)
        .then((response) => {
          this.items = response.data;
        });
    }

     public handleItemClick(id: any) {
      this.$router.push({name: 'profile', params: {id}}, () => {
            this.getSearchProfile(id);
        });
    }

    public handleAllClick() {
      this.$router.push({name: 'new-joinees'});
    }
}
